<div class="button_box">
  <ng-content></ng-content>
</div>
